import GemView from './gemView/GemView';

const appComponent = () => <GemView />

const App = appComponent;

export default App;
